<template>
  <button class="tooltip" :content="$filters.convertWords(data, replaceWords)" v-tippy="settings">
    <svg v-if="icon" class="icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="#162F47" stroke-width="2"/><path d="M8.895 8.321h1.872v6.456H8.895V8.321zm.936-.9c-.344 0-.624-.1-.84-.3a.973.973 0 01-.324-.744c0-.296.108-.544.324-.744.216-.2.496-.3.84-.3s.624.096.84.288a.923.923 0 01.324.72c0 .312-.108.572-.324.78-.216.2-.496.3-.84.3z" fill="#000"/></svg>
    <slot />
  </button>
</template>

<script>
// https://vue-tippy.netlify.app
import { directive } from 'vue-tippy'
import 'tippy.js/dist/tippy.css';

export default {
	name: 'Tooltip',

  directives: {
    tippy: directive,
  },

  props: {
  	data: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      settings: {
        theme: 'esc',
        allowHTML: true,
        placement: 'top',
        arrow: true,
        delay: 0,
        duration: [300, 250],
        followCursor: false,
        hideOnClick: true,
        maxWidth: 260,
      },
      replaceWords: [
				{ from:'[b]',  to:'<b>' },
				{ from:'[/b]', to:'</b>' },
				{	from:'[u]',  to:'<u>' },
				{	from:'[/u]', to:'</u>' },
			]
    }
  },

  mounted() {
    console.log('??', this.x);
  }
}
</script>

<style lang="scss">
  .tippy-box[data-theme~='esc'] {
    @apply text-xs bg-white text-black p-2 border border-gray-200 shadow-lg;

    .tippy-arrow {
      @apply text-white;
    }

    p {
      @apply mb-3;

      &:last-child {
        @apply mb-0;
      }
    }
  }
</style>